var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-page" }, [
    _vm._m(0),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "grid",
      },
      _vm._l(_vm.metrics, function (item) {
        return _c("div", { key: item.key, staticClass: "card" }, [
          _c("span", [_vm._v(_vm._s(item.label))]),
          _c("strong", [_vm._v(_vm._s(item.value))]),
          _c("small", [_vm._v(_vm._s(item.hint))]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("OPERATION SCREEN")]),
        _c("h2", [_vm._v("经营大屏")]),
        _c("p", [
          _vm._v(
            "由线索、工地、销售、待办、案例和账本事实表聚合，不另建快照表。"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }